import React from "react";
import { Star } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { services } from "@/mock/zebraCarsMock";

export const ServicesSection = () => {
  return (
    <section id="usluge" className="border-y border-[var(--border-light)] py-24 !bg-[#303030]">
      <div className="container max-w-[87.5rem] mx-auto px-5 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <p className="caption text-[var(--text-secondary)]">USLUGE</p>
            <h2 className="heading-2 text-[var(--text-primary)] mb-4">Sve za vašu registraciju na jednom mestu</h2>
            <p className="body-small text-[var(--text-primary)] max-w-[60ch]">
              Od prve registracije, tehničkog pregleda i osiguranja do odjave vozila i kupoprodajnih ugovora –
              Zebra Cars pokriva ceo proces umesto vas.
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Badge className="bg-transparent border-[rgba(63,72,22,0.5)] text-[#dfddd6] rounded-full px-4 py-1">
              Registracija bez šetanja i čekanja
            </Badge>
            <Badge className="bg-transparent border-[rgba(63,72,22,0.5)] text-[#dfddd6] rounded-full px-4 py-1">
              Besplatan dolazak po vozilo
            </Badge>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          <Card className="bg-[var(--bg-card)] border-[var(--border-light)] text-[var(--text-primary)] card-hover-effect flex flex-col">
            <CardHeader className="pb-4">
              <CardTitle className="heading-5 text-[var(--text-primary)]">{services[0].category}</CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
              <ul className="space-y-2 body-small">
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[0].items[0]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[0].items[1]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[0].items[2]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[0].items[3]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[0].items[4]}</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-[var(--bg-card)] border-[var(--border-light)] text-[var(--text-primary)] card-hover-effect flex flex-col">
            <CardHeader className="pb-4">
              <CardTitle className="heading-5 text-[var(--text-primary)]">{services[1].category}</CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
              <ul className="space-y-2 body-small">
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[1].items[0]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[1].items[1]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[1].items[2]}</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-[var(--bg-card)] border-[var(--border-light)] text-[var(--text-primary)] card-hover-effect flex flex-col">
            <CardHeader className="pb-4">
              <CardTitle className="heading-5 text-[var(--text-primary)]">{services[2].category}</CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
              <ul className="space-y-2 body-small">
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[2].items[0]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[2].items[1]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[2].items[2]}</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="bg-[var(--bg-card)] border-[var(--border-light)] text-[var(--text-primary)] card-hover-effect flex flex-col">
            <CardHeader className="pb-4">
              <CardTitle className="heading-5 text-[var(--text-primary)]">{services[3].category}</CardTitle>
            </CardHeader>
            <CardContent className="pt-0">
              <ul className="space-y-2 body-small">
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[3].items[0]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[3].items[1]}</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-[var(--text-secondary)]" />
                  <span>{services[3].items[2]}</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-[minmax(0,2fr)_minmax(0,1.2fr)] gap-10 items-start">
          <div>
            <Accordion
              type="single"
              collapsible
              className="w-full bg-[#302f2c] border border-[rgba(63,72,22,0.5)] rounded-xl px-4">

              <AccordionItem value="item-1">
                <AccordionTrigger className="text-[#dfddd6]">
                  Kako funkcioniše besplatan dolazak po vozilo?
                </AccordionTrigger>
                <AccordionContent className="text-[#dfddd6] body-small">
                  Dolazimo na vašu adresu na teritoriji Novog Sada, preuzimamo vozilo i vraćamo ga nakon
                  završene registracije na istu lokaciju. Uslov je da je vozilo registrovano. Ako nije,
                  obezbeđujemo povoljnu šlep službu.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-2">
                <AccordionTrigger className="text-[#dfddd6]">
                  Da li moram da budem prisutan tokom tehničkog pregleda?
                </AccordionTrigger>
                <AccordionContent className="text-[#dfddd6] body-small">
                  Ne morate – naš tim preuzima kompletan proces. Dovoljno je da donesete potrebnu dokumentaciju,
                  a mi vas obaveštavamo kada je sve gotovo.
                </AccordionContent>
              </AccordionItem>

              <AccordionItem value="item-3">
                <AccordionTrigger className="text-[#dfddd6]">
                  Koje opcije plaćanja nudite?
                </AccordionTrigger>
                <AccordionContent className="text-[#dfddd6] body-small">
                  Moguće je plaćanje na rate putem administrativne zabrane, čekova građana i kreditne kartice
                  Poštanske štedionice. Takođe vršimo uplate putem ALTA PAY sistema, kao i Wolt i Glovo uplata
                  pazara.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>

          <div className="bg-[var(--bg-card)] border border-[var(--border-light)] rounded-xl p-6 space-y-4">
            <h3 className="heading-5 flex items-center gap-2 text-[var(--text-primary)]">
              <Star className="w-4 h-4" />
              4,9 Google ocena
            </h3>
            <p className="body-small text-[#dfddd6]">Klijenti nas najčešće ističu zbog brzine, ljubaznosti i zbog toga što nema nepotrebnog zadržavanja. Naš cilj je da registraciju završite u jednom dolasku – bez stresa.


            </p>
            <p className="caption text-[#888680]">
              Napomena: Prikazana ocena je preuzeta sa Google naloga i može da varira u odnosu na trenutni broj
              recenzija.
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default ServicesSection;